import { Permission } from "../authSchema";

export type Context = {
    data: Record<string, any>;
    name: string;
};

export type Role = {
    name: string;
    permissions: Permission[];
    contexts?: Context[];
};

export enum TokenState {
    Unknown = "Unknown",
    Checking = "Checking",
    Valid = "Valid",
}

/** The session is gone at the backend (or never was), only a new login helps. */
export class SessionEndedError extends Error {
    constructor() {
        super("the session has ended");
        this.name = "SessionEndedError";
    }
}
